// src/services/purchaseService.js

export const initiatePurchase = async (purchaseData) => {
  try {
    // Retrieve the auth token from localStorage
    const authResponseData = JSON.parse(
      localStorage.getItem("authResponseData")
    );
    const token = authResponseData?.token;

    // Create headers
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    // Convert the purchaseData to a JSON string for the body
    const raw = JSON.stringify(purchaseData);

    // Fetch options
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    // Perform the fetch request to your API endpoint from the environment variable
    const fetchRequestURL = process.env.REACT_APP_PAYPAL_GENERATE_PAYMENT_URL;

    console.log('fetchRequestURL buy: ', fetchRequestURL);

    const response = await fetch(
      fetchRequestURL,
      requestOptions
    );

    // Check if the response is successful
    if (response.ok) {
      const result = await response.json(); // Parse the response as JSON
      return result; // Return the result (likely the PayPal URL)
    } else {
      // Handle errors in response status codes
      const errorText = await response.text();
      console.error("Error:", errorText);
      throw new Error("Purchase failed");
    }
  } catch (error) {
    console.error("Error initiating purchase:", error);
    throw error;
  }
};
